import "./balansheet.css";
import * as React from "react";
import Table from "@mui/material/Table";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import Drawer from "@mui/material/Drawer";
import { ButtonGroup } from "@mui/material";
import DateFilter from "./DateFilter.jsx";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import MenuIcon from "@mui/icons-material/Menu";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Header from '../Includes/Header';
import { useTheme as useAppTheme } from '../../contexts/ThemeContext';
import { styled } from "@mui/material/styles";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableFooter from "@mui/material/TableFooter";
import { useState, useMemo } from "react";
import { useEffect, useRef } from "react";
import CancelIcon from '@mui/icons-material/Cancel';
import { Card, Button, Modal, Grid, TextField, FormControl, InputLabel, Select, MenuItem, FormHelperText, Paper, Stack, TablePagination } from "@mui/material";
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { DialogContentText } from '@mui/material';
import Menu from '@mui/material/Menu';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import Autocomplete from "@mui/material/Autocomplete";
import useMediaQuery from "@mui/material/useMediaQuery";
import DeleteIcon from '@mui/icons-material/Delete';
import CircularProgress from "@mui/material/CircularProgress";
import json2mq from "json2mq";
import { Link } from 'react-router-dom';
import {
  retrieveGymMember,
  AutocompleteMember,
  StatusMember,
  DeleteJoinMember,
} from "../Apihelper/MemberApiHelpr";

import {
    balanceSheetRetrive,
    AutocompleteBalance
  } from "../Apihelper/BalanceSheet.js";
import { verifyBalanceSheetPassword } from "../Apihelper/ApiHelperUser";
import dayjs from "dayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import TableChartIcon from "@mui/icons-material/TableChart";
import ClearAllIcon from "@mui/icons-material/ClearAll";
import SearchIcon from "@mui/icons-material/Search";
import InputAdornment from "@mui/material/InputAdornment";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import { useNavigate } from "react-router-dom";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import AppToast from '../../components/Toast/AppToast';

/**
 * Parse amount from API. Must NOT strip "." — that was breaking values like "3000.00"
 * (they became "300000"). Only remove currency markers, spaces, and thousand commas.
 */
function parsePaymentAmount(val) {
  if (val == null || val === "") return 0;
  if (typeof val === "number" && Number.isFinite(val)) return val;
  let s = String(val).trim();
  s = s.replace(/₹/g, "");
  s = s.replace(/rs\.?/gi, "");
  s = s.replace(/\s/g, "");
  s = s.replace(/,/g, "");
  const n = parseFloat(s);
  return Number.isFinite(n) ? n : 0;
}

function sumPaymentsAmount(payments) {
  if (!Array.isArray(payments)) return 0;
  return payments.reduce((sum, row) => sum + parsePaymentAmount(row.amount), 0);
}

function formatInrTotal(n) {
  return Number(n).toLocaleString("en-IN", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}

function fmtDateOnly(datetimeStr) {
  if (!datetimeStr) return '';
  const parts = String(datetimeStr).split(' ')[0].split('-');
  if (parts.length !== 3) return datetimeStr;
  return `${parts[2]}-${parts[1]}-${parts[0]}`;
}

function truncateCell(s, max) {
  const str = String(s ?? "");
  return str.length <= max ? str : `${str.slice(0, max - 1)}…`;
}

// Build Excel (.xlsx) from payments with readable column widths + grand total row
function buildExcelFromPayments(payments) {
  const headers = ["#", "Invoice Number", "Member Name", "Payment Type", "Amount", "Mode of Payment", "Date", "Entry Date"];
  const rows = payments.map((row, i) => [
    i + 1,
    row.invoice_number ?? "",
    row.member_name ?? "",
    row.payment_type ?? "",
    row.amount ?? "",
    row.mode_of_payment ?? "",
    row.date ?? "",
    row.created_at ?? "",
  ]);
  const grandTotal = sumPaymentsAmount(payments);
  const totalRow = ["", "", "", "TOTAL", Number(grandTotal.toFixed(2)), "", "", ""];
  const ws = XLSX.utils.aoa_to_sheet([headers, ...rows, [], totalRow]);

  ws["!cols"] = [
    { wch: 5 },   // #
    { wch: 16 },  // Invoice Number
    { wch: 28 },  // Member Name
    { wch: 22 },  // Payment Type
    { wch: 14 },  // Amount
    { wch: 16 },  // Mode of Payment
    { wch: 22 },  // Date
    { wch: 22 },  // Entry Date
  ];

  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "Balance Sheet");
  return XLSX.write(wb, { bookType: "xlsx", type: "array" });
}

/** PDF (landscape) with all rows, paginated, and grand total at the end. */
function downloadBalanceSheetPDF(payments, filename, periodSubtitle) {
  const doc = new jsPDF({ orientation: "landscape", unit: "mm", format: "a4" });
  const pageW = doc.internal.pageSize.getWidth();
  const margin = 10;
  let y = 12;
  doc.setFontSize(15);
  doc.setTextColor(30, 58, 138);
  doc.text("Balance Sheet", margin, y);
  y += 7;
  doc.setFontSize(9);
  doc.setTextColor(60, 60, 60);
  doc.text(periodSubtitle, margin, y);
  y += 5;
  doc.text(`Generated: ${dayjs().format("DD MMM YYYY, hh:mm A")}`, margin, y);
  y += 8;

  const grandTotal = sumPaymentsAmount(payments);
  const colX = [margin, margin + 10, margin + 34, margin + 98, margin + 142, margin + 162, margin + 188, margin + 222];
  doc.setFontSize(8);
  doc.setTextColor(0, 0, 0);
  doc.setFont("helvetica", "bold");
  const head = ["#", "Invoice", "Member", "Payment type", "Amount", "Mode", "Date", "Entry Date"];
  head.forEach((h, i) => doc.text(h, colX[i], y));
  y += 5;
  doc.setDrawColor(200);
  doc.line(margin, y, pageW - margin, y);
  y += 5;

  doc.setFont("helvetica", "normal");
  const maxY = 192;
  payments.forEach((row, idx) => {
    if (y > maxY) {
      doc.addPage();
      y = 12;
    }
    const cells = [
      String(idx + 1),
      truncateCell(row.invoice_number, 16),
      truncateCell(row.member_name, 28),
      truncateCell(row.payment_type, 18),
      truncateCell(row.amount, 12),
      truncateCell(row.mode_of_payment, 10),
      truncateCell(row.date, 22),
      truncateCell(row.created_at, 22),
    ];
    cells.forEach((c, i) => doc.text(c, colX[i], y));
    y += 5;
  });

  y += 6;
  if (y > maxY) {
    doc.addPage();
    y = 12;
  }
  doc.setFont("helvetica", "bold");
  doc.setFontSize(11);
  doc.setTextColor(30, 58, 138);
  doc.text(`Total amount (INR): ${formatInrTotal(grandTotal)}`, colX[3], y);
  doc.save(filename);
}

function downloadExcel(buffer, filename) {
  const blob = new Blob([buffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}

const useStyles = styled((theme) => ({
  tableContainer: {
    maxWidth: 600,
    margin: "0 auto",
  },
  table: {
    display: "none", // Hide the table on all screens
    [theme.breakpoints.down("sm")]: {
      display: "table", // Show the table on small screens only (mobile view)
    },
  },
  cardContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    [theme.breakpoints.down("sm")]: {
      display: "none", // Hide the card container on small screens (mobile view)
    },
  },
  card: {
    width: "100%",
    margin: "8px",
    padding: "16px",
    borderRadius: "8px",
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
    [theme.breakpoints.down("sm")]: {
      maxWidth: "300px", // Adjust the card width as needed
    },
  },
}));
const drawerWidth = 292;

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.primary.main,
    color: '#ffffff',
    fontWeight: 600,
    fontSize: '0.875rem',
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: '0.875rem',
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: '#f8fafc',
  },
  '&:nth-of-type(even)': {
    backgroundColor: '#ffffff',
  },
}));

const ClickableInvoice = styled('span')(({ theme }) => ({
  color: theme.palette.primary.main,
  textDecoration: 'underline',
  cursor: 'pointer',
  transition: 'all 0.2s ease',
  '&:hover': {
    color: theme.palette.primary.dark,
    backgroundColor: '#e8f0fe',
    padding: '4px 8px',
    margin: '-4px -8px',
    borderRadius: '4px',
  },
}));

function BalanceSheet(props) {
  const navigate = useNavigate();
  const { colors: appColors } = useAppTheme();
  const [deleteConfirmationId, setDeleteConfirmationId] = useState(null);
  const { window1 } = props;
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const [loading, setLoading] = useState(false);
  const [openConfirmation, setOpenConfirmation] = useState(false);
  const [isActive, setIsActive] = useState(false);
  const dateRef = useRef();
  const [age, setAge] = React.useState('');
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalCount, setTotalCount] = useState(0);
  const [status, setstatus] = useState('');
  const [isModalOpen, setModalOpen] = useState(true); // Modal starts open
  const [password, setPassword] = useState(''); // For storing input
  const [error, setError] = useState(''); // For displaying error messages
  const [isAuthenticated, setAuthenticated] = useState(false); // Access control
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    try {
      setIsAdmin(JSON.parse(localStorage.getItem('userdata'))?.role === 'admin');
    } catch {
      setIsAdmin(false);
    }
  }, []);
  const [verifying, setVerifying] = useState(false);
  const handlePasswordSubmit = async () => {
    try {
      setVerifying(true);
      const userDataObj = JSON.parse(localStorage.getItem("userdata"));
      const userToken = userDataObj?.token;
      const userId = userDataObj?.id;
      const res = await verifyBalanceSheetPassword(userToken, userId, password);
      if (res.code === 200 || res.code === "200") {
        setAuthenticated(true);
        setModalOpen(false);
        setError('');
      } else {
        setError(res.message || 'Incorrect password. Please try again.');
      }
    } catch (err) {
      setError('Something went wrong while verifying the password.');
    } finally {
      setVerifying(false);
    }
  };

  const handlePasswordCancel = () => {
    setModalOpen(false);
    setPassword('');
    setError('');
    navigate(-1);
  };

  useEffect(() => {
    if (!isAuthenticated) return;
    if (isAdmin) {
      fetchData();
    } else {
      // Non-admins default to the last 3 days (today, yesterday, day before)
      const fmtLocal = (d) => {
        const y = d.getFullYear();
        const m = String(d.getMonth() + 1).padStart(2, '0');
        const day = String(d.getDate()).padStart(2, '0');
        return `${y}-${m}-${day}`;
      };
      const today = new Date();
      const dayBefore = new Date(today);
      dayBefore.setDate(today.getDate() - 2);
      handleApplydatecustom({ fromDateval: fmtLocal(dayBefore), toDateval: fmtLocal(today) });
    }
  }, [isAuthenticated, isAdmin]);
  const [openDeleteConfirmation, setOpenDeleteConfirmation] = useState(false);
  const handleChange = (event) => {
    setAge(event.target.value);
  };

  const mediaQueryVar = useMediaQuery(
    json2mq({
      minWidth: 600,
    })
  );
  const handleToggle = (id,status) => {
    setOpenConfirmation(true);
   const newStatus = status === 1 ? 0 : 1;
  setstatus(newStatus);
  setDeleteConfirmationId(id);
  setIsActive(newStatus === 0);

  };

  const handleConfirm = async() => {
    // setIsActive(!isActive);
    // setOpenConfirmation(false);

    try {
        const userData = localStorage.getItem("userdata");
        const userDataObj = JSON.parse(userData);
        const userToken = userDataObj.token;
        const userId = userDataObj.id; 
     
      
        const res = await StatusMember(userToken,userId,status, deleteConfirmationId);

        if (res.code == "200") {
            handleSnackbarOpen(res.message, 'success');
            setIsActive(!isActive);
            setOpenConfirmation(false);
          //  setOpenDeleteConfirmation(false);
            fetchData();
        } else {
            handleSnackbarOpen(res.message, 'error');
            //  console.error(error); // Handle error
        }
    } catch (error) {
        console.error(error);
        // Handle errors
    }
  };
  const handleCancel = () => {
    setOpenConfirmation(false);
  };
 
 

 
  const drawer = (
    <div className="d-flex flex-column h-100">
      <Header />
    </div>
  );
 
 
  const [options, setOptions] = useState([]);
  const [fetchdatarow, setetchdatarow] = useState([]);
  const balanceSheetPageTotal = useMemo(
    () => sumPaymentsAmount(fetchdatarow),
    [fetchdatarow]
  );
  const ITEM_HEIGHT = 48;
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [openToast, setOpenToast] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('success'); // Default to 'success'
  const [datelist, setDatelist] = useState([]);
  const [fromDate, setFromDate] = useState("");
  const [todate, settodate] = useState("");
  const [dateFilterBy, setDateFilterBy] = useState("entry"); // "entry" (created_at) or "payment" (actual payment date)
  /** Remount Autocomplete so search text clears with "Clear filters" */
  const [balanceSearchResetKey, setBalanceSearchResetKey] = useState(0);
  const [openReportModal, setOpenReportModal] = useState(false);
  const [reportDateType, setReportDateType] = useState("today");
  const [reportFromDate, setReportFromDate] = useState(() => dayjs());
  const [reportToDate, setReportToDate] = useState(() => dayjs());
  const [reportLoading, setReportLoading] = useState(false);
  const open = Boolean(anchorEl);
  const handleSnackbarOpen = (message, severity) => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setOpenToast(true);
  };
  const handleToastClose = () => {
    setOpenToast(false);
  };
  const handleNavigate = (invoiceNumber) => {
    navigate('/invoice', { state: { invoice_number: invoiceNumber } });
  };
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const fetchData = async (value = '', newPage = 0, newRowsPerPage = rowsPerPage) => {
    setLoading(true);
    try {
        const userData = localStorage.getItem("userdata");
        const userDataObj = JSON.parse(userData);
        const userToken = userDataObj.token;
        const userId = userDataObj.id;
        const res = await balanceSheetRetrive(userToken, userId, value, newRowsPerPage, newPage * newRowsPerPage, datelist, fromDate, "", dateFilterBy);

        if (res.code == "200") {
            setetchdatarow(res.payments);
            const rawTotal = res.total_count ?? res.recordsTotal ?? res.recordsFiltered ?? res.total ?? null;
            if (rawTotal !== null) {
                setTotalCount(rawTotal);
            } else {
                setTotalCount(
                    res.payments.length < newRowsPerPage
                        ? newPage * newRowsPerPage + res.payments.length
                        : (newPage + 1) * newRowsPerPage + 1
                );
            }
        }
    } catch (error) {
        console.error(error);
    } finally {
        setLoading(false);
    }
};

const handleChangePage = (event, newPage) => {
    setPage(newPage);
    fetchData('', newPage, rowsPerPage);
};

const handleChangeRowsPerPage = (event) => {
    const newRowsPerPage = parseInt(event.target.value, 10);
    setRowsPerPage(newRowsPerPage);
    setPage(0);
    fetchData('', 0, newRowsPerPage);
};

const handleApplydatecustom = async ({ fromDateval, toDateval, value = '' }) => {
  settodate(toDateval);
  setFromDate(fromDateval);
  setPage(0);
  setLoading(true);
  try {
    const userData = localStorage.getItem("userdata");
    const userDataObj = JSON.parse(userData);
    const userToken = userDataObj.token;
    const userId = userDataObj.id;
    const res = await balanceSheetRetrive(userToken, userId, value, rowsPerPage, 0, datelist, fromDateval, toDateval, dateFilterBy);
    if (res.code == "200") {
      setetchdatarow(res.payments);
      const rawTotal = res.total_count ?? res.recordsTotal ?? res.recordsFiltered ?? res.total ?? null;
      if (rawTotal !== null) {
        setTotalCount(rawTotal);
      } else {
        setTotalCount(res.payments.length < rowsPerPage ? res.payments.length : rowsPerPage + 1);
      }
    } else {
      setetchdatarow([]);
      setTotalCount(0);
    }
  } catch (error) {
    console.error("Error:", error);
  } finally {
    setLoading(false);
  }
};
const handleDateFilterByChange = async (event, newValue) => {
  if (!newValue) return;
  setDateFilterBy(newValue);
  setPage(0);
  setLoading(true);
  try {
    const userData = localStorage.getItem("userdata");
    const userDataObj = JSON.parse(userData);
    const userToken = userDataObj.token;
    const userId = userDataObj.id;
    const res = await balanceSheetRetrive(userToken, userId, '', rowsPerPage, 0, datelist, fromDate, todate, newValue);
    if (res.code == "200") {
      setetchdatarow(res.payments);
      const rawTotal = res.total_count ?? res.recordsTotal ?? res.recordsFiltered ?? res.total ?? null;
      setTotalCount(rawTotal !== null ? rawTotal : (res.payments.length < rowsPerPage ? res.payments.length : rowsPerPage + 1));
    } else {
      setetchdatarow([]);
      setTotalCount(0);
    }
  } catch (error) {
    console.error("Error:", error);
  } finally {
    setLoading(false);
  }
};

const handleApplydate = async (selectedValue, value = '') => {
  setDatelist(selectedValue);
  setPage(0);
  setLoading(true);
  try {
    const userData = localStorage.getItem("userdata");
    const userDataObj = JSON.parse(userData);
    const userToken = userDataObj.token;
    const userId = userDataObj.id;
    const data = await balanceSheetRetrive(userToken, userId, value, rowsPerPage, 0, selectedValue, "", "", dateFilterBy);
    if (data.code == "200") {
      setetchdatarow(data.payments);
      const rawTotal = data.total_count ?? data.recordsTotal ?? data.recordsFiltered ?? data.total ?? null;
      if (rawTotal !== null) {
        setTotalCount(rawTotal);
      } else {
        setTotalCount(data.payments.length < rowsPerPage ? data.payments.length : rowsPerPage + 1);
      }
    } else {
      setetchdatarow([]);
      setTotalCount(0);
    }
  } catch (error) {
    console.error("Error:", error);
  } finally {
    setLoading(false);
  }
};
  useEffect(() => {
   
    fetchData();
}, []);


const handleSearchChange = (event, value) => {
  setPage(0);
  fetchData(value || '', 0, rowsPerPage);
};

/** Reset search + date filters and load balance sheet with no filters (same as fresh page). */
const handleClearAllFilters = async () => {
  setDatelist([]);
  setFromDate("");
  settodate("");
  setDateFilterBy("entry");
  setPage(0);
  setOptions([]);
  setBalanceSearchResetKey((k) => k + 1);
  if (dateRef.current?.handleResetClick) {
    dateRef.current.handleResetClick();
  }
  setLoading(true);
  try {
    const userData = localStorage.getItem("userdata");
    const userDataObj = JSON.parse(userData);
    const userToken = userDataObj.token;
    const userId = userDataObj.id;
    const res = await balanceSheetRetrive(userToken, userId, "", rowsPerPage, 0, [], "", "");
    if (res.code == "200" || res.code === 200) {
      const payments = res.payments || [];
      setetchdatarow(payments);
      const rawTotal = res.total_count ?? res.recordsTotal ?? res.recordsFiltered ?? res.total ?? null;
      if (rawTotal !== null) {
        setTotalCount(rawTotal);
      } else {
        setTotalCount(payments.length < rowsPerPage ? payments.length : rowsPerPage + 1);
      }
    } else {
      handleSnackbarOpen(res.message || "Failed to load data", "error");
    }
  } catch (error) {
    console.error(error);
    handleSnackbarOpen("Failed to clear filters", "error");
  } finally {
    setLoading(false);
  }
};

const handleOpenReportModal = () => {
  setReportDateType("today");
  setReportFromDate(dayjs());
  setReportToDate(dayjs());
  setOpenReportModal(true);
};

const handleGenerateReport = async (format /* "excel" | "pdf" */) => {
  setReportLoading(true);
  try {
    const userData = localStorage.getItem("userdata");
    const userDataObj = JSON.parse(userData);
    const userToken = userDataObj.token;
    const userId = userDataObj.id;
    let datelist = "today";
    let fromDateVal = "";
    let toDateVal = "";
    if (reportDateType === "yesterday") {
      datelist = "yesterday";
    } else if (reportDateType === "custom") {
      fromDateVal = reportFromDate.format("YYYY-MM-DD");
      toDateVal = reportToDate.format("YYYY-MM-DD");
    }
    const res = await balanceSheetRetrive(
      userToken,
      userId,
      "",
      5000,
      0,
      reportDateType === "custom" ? [] : datelist,
      fromDateVal,
      reportDateType === "custom" ? toDateVal : "",
      dateFilterBy
    );
    if (res.code === "200" || res.code === 200) {
      const payments = res.payments || [];
      const label =
        reportDateType === "custom"
          ? `${fromDateVal}_to_${toDateVal}`
          : reportDateType === "yesterday"
          ? dayjs().subtract(1, "day").format("YYYY-MM-DD")
          : dayjs().format("YYYY-MM-DD");
      const periodSubtitle =
        reportDateType === "custom"
          ? `Period: ${fromDateVal} to ${toDateVal}`
          : reportDateType === "yesterday"
          ? `Period: Yesterday (${dayjs().subtract(1, "day").format("DD MMM YYYY")})`
          : `Period: Today (${dayjs().format("DD MMM YYYY")})`;
      const grandTotal = sumPaymentsAmount(payments);
      const totalStr = formatInrTotal(grandTotal);

      if (format === "pdf") {
        downloadBalanceSheetPDF(payments, `BalanceSheet_Report_${label}.pdf`, periodSubtitle);
        handleSnackbarOpen(
          `PDF saved (${payments.length} rows · Total ₹${totalStr})`,
          "success"
        );
      } else {
        const buffer = buildExcelFromPayments(payments);
        downloadExcel(buffer, `BalanceSheet_Report_${label}.xlsx`);
        handleSnackbarOpen(
          `Excel saved (${payments.length} rows · Total ₹${totalStr})`,
          "success"
        );
      }
      setOpenReportModal(false);
    } else {
      handleSnackbarOpen(res.message || "Failed to load report data", "error");
    }
  } catch (err) {
    console.error(err);
    handleSnackbarOpen("Failed to generate report", "error");
  } finally {
    setReportLoading(false);
  }
};


const handleInputChange = async (value) => {
  if (value.length >= 3) {
  try {
      const userData = localStorage.getItem("userdata");
      const userDataObj = JSON.parse(userData);
      const userToken = userDataObj.token;
      const userId = userDataObj.id; // Assuming you have a userId in userdata
      const searchText = value; // Example search text
    
      const res = await AutocompleteBalance(userToken, userId, searchText);

      if (res.code == "200") {
          const names = res.data.map(item => item.search_text);
          setOptions(names);
      } else {
          handleSnackbarOpen(res.message, 'error');
          //  console.error(error); // Handle error
      }
  } catch (error) {
      console.error(error);
      // Handle errors
  }
}
};
const handleDelete = (id) => {
  handleClose();
  setDeleteConfirmationId(id);
  setOpenDeleteConfirmation(true,id);
};

const handleConfirmDelete =async (id) => {
  // setSnackbarMessage('package deleted successfully');
  // setSnackbarSeverity('error');
  // setOpenDeleteConfirmation(false);
  // setOpenToast(true); // Show toast message

  if (deleteConfirmationId !== null) {
   
      try {
          const userData = localStorage.getItem("userdata");
          const userDataObj = JSON.parse(userData);
          const userToken = userDataObj.token;
          const userId = userDataObj.id; 
       
        
          const res = await DeleteJoinMember(userToken, userId, deleteConfirmationId);
  
          if (res.code == "200") {
              handleSnackbarOpen(res.message, 'success');
              setOpenDeleteConfirmation(false);
              fetchData()
          } else {
              handleSnackbarOpen(res.message, 'error');
              //  console.error(error); // Handle error
          }
      } catch (error) {
          console.error(error);
          // Handle errors
      }
  }
  };


const handleCancelDelete = () => {
  setOpenDeleteConfirmation(false);
};

const handleCardPress = async (id) => {
  try {
    navigate('/memberdetails', {
      state: {
        id: id,
        random_no: Math.random(),
      },
    });
  } catch (error) {
    console.error("Error:", error);
  }
};
React.useEffect(() => {
  const storedData = localStorage.getItem("userdata");
  if (!storedData) {
    // User is not logged in, no need to redirect
    navigate('/');
  }
  
}, []);
const handleCanceladd = () => {
  navigate(-1); // Navigate to the previous page
};
const applyPredefinedDate = (type) => {
  const today = new Date();
  let date;

  if (type === 'today') {
    date = today;
  } else if (type === 'yesterday') {
    date = new Date(today);
    date.setDate(today.getDate() - 1);
  } else if (type === 'dayBeforeYesterday') {
    date = new Date(today);
    date.setDate(today.getDate() - 2);
  }

  setSelectedDate(date.toLocaleDateString());
  console.log(`Applied date filter: ${type} -> ${date}`);
};

  return (
    <Box sx={{ display: 'flex', bgcolor: '#f0f2f5', minHeight: '100vh' }}>
      <CssBaseline />
      {drawer}
      
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: 3,
          width: { sm: `calc(100% - ${drawerWidth}px)` },
          ...(!isAuthenticated && {
            filter: 'blur(10px)',
            pointerEvents: 'none',
            userSelect: 'none',
          }),
        }}
      >
        <Box sx={{ mb: 4 }}>
          <Typography variant="h5" sx={{ color: appColors.leaf, fontWeight: 600, mb: 2 }}>
            Balance Sheet
          </Typography>

          <Box
            sx={{
              bgcolor: '#ffffff',
              border: '1px solid #e2e8f0',
              borderRadius: 3,
              p: 2,
            }}
          >
            <Box sx={{
              display: 'flex',
              flexWrap: 'wrap',
              gap: 1.5,
              alignItems: 'center',
              justifyContent: 'space-between',
            }}>
              <Box sx={{ display: 'inline-flex', alignItems: 'center', gap: 1 }}>
                <Typography sx={{ fontSize: '0.7rem', fontWeight: 700, color: '#94a3b8', textTransform: 'uppercase', letterSpacing: 0.4, whiteSpace: 'nowrap' }}>
                  Filter by
                </Typography>
                <ToggleButtonGroup
                  value={dateFilterBy}
                  exclusive
                  onChange={handleDateFilterByChange}
                  size="small"
                  sx={{
                    bgcolor: '#f1f5f9',
                    borderRadius: '999px',
                    p: 0.4,
                    '& .MuiToggleButton-root': {
                      textTransform: 'none',
                      fontWeight: 600,
                      fontSize: '0.8rem',
                      px: 1.5,
                      py: 0.4,
                      border: 'none',
                      borderRadius: '999px !important',
                      color: '#64748b',
                      '&.Mui-selected': {
                        bgcolor: appColors.leaf,
                        color: '#fff',
                        '&:hover': { bgcolor: appColors.pine },
                      },
                    },
                  }}
                >
                  <ToggleButton value="entry">Entry Date</ToggleButton>
                  <ToggleButton value="payment">Payment Date</ToggleButton>
                </ToggleButtonGroup>
              </Box>

              <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', alignItems: 'center' }}>
                <ToggleButtonGroup
                  value={Array.isArray(datelist) ? false : datelist}
                  exclusive
                  onChange={(event, value) => value && handleApplydate(value)}
                  size="small"
                  sx={{
                    bgcolor: '#f1f5f9',
                    borderRadius: '999px',
                    p: 0.4,
                    '& .MuiToggleButton-root': {
                      textTransform: 'none',
                      fontWeight: 600,
                      fontSize: '0.8rem',
                      px: 1.5,
                      py: 0.4,
                      border: 'none',
                      borderRadius: '999px !important',
                      color: '#64748b',
                      '&.Mui-selected': {
                        bgcolor: appColors.leaf,
                        color: '#fff',
                        '&:hover': { bgcolor: appColors.pine },
                      },
                    },
                  }}
                >
                  <ToggleButton value="today">Today</ToggleButton>
                  <ToggleButton value="yesterday">Yesterday</ToggleButton>
                  <ToggleButton value="daybeforeyesterday">Day before</ToggleButton>
                </ToggleButtonGroup>

                {isAdmin && (
                <DateFilter
                  ref={dateRef}
                     onApplycustomdate={handleApplydatecustom}
                     onApply={handleApplydate}
                    />
                )}

                <Button
                  variant="text"
                  size="small"
                  startIcon={<ClearAllIcon sx={{ fontSize: 18 }} />}
                  onClick={handleClearAllFilters}
                  sx={{
                    textTransform: 'none',
                    fontWeight: 600,
                    color: '#64748b',
                    px: 1.25,
                    '&:hover': {
                      bgcolor: 'rgba(148, 163, 184, 0.12)',
                    },
                  }}
                >
                  Clear
                </Button>
              </Box>
            </Box>

            <Box sx={{
              display: 'flex',
              flexWrap: 'wrap',
              gap: 1.5,
              alignItems: 'center',
              justifyContent: 'space-between',
              mt: 2,
            }}>
              <Autocomplete
                freeSolo
                disableClearable
                options={options}
                onInputChange={(event, value) => handleInputChange(value)}
                onChange={(event, value) => handleSearchChange(event, value)}
                sx={{ width: { xs: '100%', sm: 320 } }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    placeholder="Search by member, invoice, mode..."
                    size="small"
                    sx={{
                      backgroundColor: '#f8fafc',
                      '& .MuiOutlinedInput-root': {
                        borderRadius: '999px',
                        '& fieldset': {
                          borderColor: '#e2e8f0',
                        },
                        '&:hover fieldset': {
                          borderColor: appColors.leaf,
                        },
                        '&.Mui-focused fieldset': {
                          borderColor: appColors.leaf,
                        },
                        '&.Mui-focused': {
                          backgroundColor: '#ffffff',
                        },
                      },
                    }}
                    InputProps={{
                      ...params.InputProps,
                      type: 'search',
                      startAdornment: (
                        <InputAdornment position="start">
                          <SearchIcon sx={{ fontSize: 20, color: '#94a3b8' }} />
                        </InputAdornment>
                      ),
                    }}
                  />
                )}
              />

              {/* Export — admin only; opens date dialog then Excel/PDF download */}
              {isAdmin && (
              <Tooltip title="Pick a date range, then download Excel or PDF (includes row total)">
                <Stack direction="row" spacing={1}>
                  <Button
                    variant="outlined"
                    size="small"
                    startIcon={<TableChartIcon sx={{ fontSize: 16 }} />}
                    onClick={handleOpenReportModal}
                    sx={{
                      borderColor: '#059669',
                      color: '#047857',
                      textTransform: 'none',
                      fontWeight: 600,
                      borderRadius: '999px',
                      '&:hover': { borderColor: '#047857', bgcolor: 'rgba(5, 150, 105, 0.06)' },
                    }}
                  >
                    Excel
                  </Button>
                  <Button
                    variant="outlined"
                    size="small"
                    startIcon={<PictureAsPdfIcon sx={{ fontSize: 16 }} />}
                    onClick={handleOpenReportModal}
                    sx={{
                      borderColor: '#b91c1c',
                      color: '#b91c1c',
                      textTransform: 'none',
                      fontWeight: 600,
                      borderRadius: '999px',
                      '&:hover': { borderColor: '#991b1b', bgcolor: 'rgba(185, 28, 28, 0.06)' },
                    }}
                  >
                    PDF
                  </Button>
                </Stack>
              </Tooltip>
              )}
            </Box>
          </Box>
        </Box>

        <Paper
          elevation={0}
                sx={{
            borderRadius: 2,
            overflow: 'hidden',
            bgcolor: '#ffffff',
            boxShadow: '0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1)',
            filter: isModalOpen ? 'blur(5px)' : 'none',
          }}
        >
          {loading ? (
            <Box sx={{ 
              display: 'flex', 
              justifyContent: 'center', 
              alignItems: 'center', 
              p: 4 
            }}>
              <CircularProgress sx={{ color: appColors.leaf }} />
            </Box>
          ) : (
            <TableContainer>
              <Table sx={{ minWidth: 650 }} size="medium">
                <TableHead>
                  <TableRow>
                    <StyledTableCell>#</StyledTableCell>
                    <StyledTableCell>Invoice Number</StyledTableCell>
                    <StyledTableCell>Member Name</StyledTableCell>
                    <StyledTableCell>Payment Type</StyledTableCell>
                    <StyledTableCell>Amount</StyledTableCell>
                    <StyledTableCell>Mode of Payment</StyledTableCell>
                    <StyledTableCell>Date</StyledTableCell>
                    <StyledTableCell>Entry Date</StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {fetchdatarow.map((row, index) => (
                    <StyledTableRow key={row.id}>
                      <StyledTableCell>{page * rowsPerPage + index + 1}</StyledTableCell>
                      <StyledTableCell>
                        <ClickableInvoice onClick={() => handleNavigate(row.invoice_number)}>
    {row.invoice_number}
                        </ClickableInvoice>
                      </StyledTableCell>
                      <StyledTableCell>{row.member_name}</StyledTableCell>
                      <StyledTableCell>{row.payment_type}</StyledTableCell>
                      <StyledTableCell>₹{row.amount}</StyledTableCell>
                      <StyledTableCell>{row.mode_of_payment}</StyledTableCell>
                      <StyledTableCell>{fmtDateOnly(row.date)}</StyledTableCell>
                      <StyledTableCell sx={{ color: '#6b7280', fontSize: '0.8rem' }}>{fmtDateOnly(row.created_at)}</StyledTableCell>
                    </StyledTableRow>
            ))}
          </TableBody>
          {!loading && fetchdatarow.length > 0 && (
            <TableFooter>
              <TableRow sx={{ backgroundColor: "rgba(31, 122, 84, 0.08)" }}>
                <StyledTableCell colSpan={4} align="right" sx={{ fontWeight: 700, borderBottom: "none" }}>
                  Total amount
                </StyledTableCell>
                <StyledTableCell sx={{ fontWeight: 700, borderBottom: "none" }}>
                  ₹{formatInrTotal(balanceSheetPageTotal)}
                </StyledTableCell>
                <StyledTableCell colSpan={3} sx={{ borderBottom: "none" }} />
              </TableRow>
            </TableFooter>
          )}
        </Table>
            </TableContainer>
          )}
        </Paper>

        <TablePagination
          component="div"
          count={totalCount}
          page={page}
          onPageChange={handleChangePage}
          rowsPerPage={rowsPerPage}
          rowsPerPageOptions={[10, 20, 50]}
          onRowsPerPageChange={handleChangeRowsPerPage}
          showFirstButton
          showLastButton
          sx={{ '& .MuiTablePagination-actions': { mr: 8 } }}
          labelDisplayedRows={({ page: p, count }) =>
            `Page ${p + 1} of ${Math.ceil(count / rowsPerPage)}  |  Total: ${count} records`
          }
        />

      <AppToast open={openToast} message={snackbarMessage} severity={snackbarSeverity} onClose={handleToastClose} />

    <Dialog
      open={openReportModal}
      onClose={() => !reportLoading && setOpenReportModal(false)}
      maxWidth="xs"
      fullWidth
      PaperProps={{ sx: { borderRadius: 2 } }}
    >
      <DialogTitle sx={{ bgcolor: appColors.leaf, color: 'white', fontWeight: 600, py: 1.5, fontSize: '1rem' }}>
        Export report
      </DialogTitle>
      <DialogContent sx={{ pt: 2, pb: 1 }}>
        <Typography variant="caption" sx={{ color: 'text.secondary', fontWeight: 600, textTransform: 'uppercase', letterSpacing: 0.5, display: 'block', mb: 1 }}>
          Date range
        </Typography>
        <ToggleButtonGroup
          value={reportDateType}
          exclusive
          size="small"
          fullWidth
          onChange={(_, v) => v != null && setReportDateType(v)}
          sx={{ mb: 2 }}
        >
          <ToggleButton value="today" sx={{ textTransform: 'none', flex: 1 }}>Today</ToggleButton>
          <ToggleButton value="yesterday" sx={{ textTransform: 'none', flex: 1 }}>Yesterday</ToggleButton>
          <ToggleButton value="custom" sx={{ textTransform: 'none', flex: 1 }}>Custom</ToggleButton>
        </ToggleButtonGroup>
        {reportDateType === "custom" && (
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <DatePicker
                  label="From date"
                  value={reportFromDate}
                  onChange={(d) => d && setReportFromDate(d)}
                  format="DD/MM/YYYY"
                  slotProps={{ textField: { fullWidth: true, size: "small" } }}
                />
              </Grid>
              <Grid item xs={6}>
                <DatePicker
                  label="To date"
                  value={reportToDate}
                  onChange={(d) => d && setReportToDate(d)}
                  format="DD/MM/YYYY"
                  slotProps={{ textField: { fullWidth: true, size: "small" } }}
                />
              </Grid>
            </Grid>
          </LocalizationProvider>
        )}
      </DialogContent>
      <DialogActions sx={{ px: 2, py: 1.5 }}>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          width="100%"
          flexWrap="wrap"
          gap={1}
        >
          <Button
            size="small"
            onClick={() => setOpenReportModal(false)}
            sx={{ textTransform: 'none', color: '#64748b' }}
          >
            Cancel
          </Button>
          <ButtonGroup
            variant="contained"
            size="small"
            disabled={reportLoading || (reportDateType === "custom" && (!reportFromDate || !reportToDate))}
          >
            <Button
              onClick={() => handleGenerateReport("excel")}
              sx={{ bgcolor: '#059669', '&:hover': { bgcolor: '#047857' }, textTransform: 'none', px: 1.25 }}
              startIcon={<TableChartIcon sx={{ fontSize: 18 }} />}
            >
              {reportLoading ? "…" : "Excel"}
            </Button>
            <Button
              onClick={() => handleGenerateReport("pdf")}
              sx={{ bgcolor: '#b91c1c', '&:hover': { bgcolor: '#991b1b' }, textTransform: 'none', px: 1.25 }}
              startIcon={<PictureAsPdfIcon sx={{ fontSize: 18 }} />}
            >
              {reportLoading ? "…" : "PDF"}
            </Button>
          </ButtonGroup>
        </Stack>
      </DialogActions>
    </Dialog>

    <Modal
      open={isModalOpen}
      onClose={handlePasswordCancel}
      aria-labelledby="password-modal-title"
      aria-describedby="password-modal-description"
      slotProps={{
        backdrop: {
          sx: {
            backdropFilter: 'blur(12px)',
            backgroundColor: 'rgba(15, 23, 42, 0.6)',
          },
        },
      }}
    >
          <Box sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 420,
          maxWidth: '90vw',
          background: 'linear-gradient(145deg, rgba(255,255,255,0.98) 0%, rgba(248,250,252,0.98) 100%)',
          borderRadius: 3,
          boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25), 0 0 0 1px rgba(31, 122, 84, 0.08)',
          p: 4,
          border: '1px solid rgba(31, 122, 84, 0.12)',
          }}>
            <Typography id="password-modal-title" variant="h5" component="h2" sx={{ color: appColors.leaf, mb: 0.5, fontWeight: 700, letterSpacing: '-0.02em' }}>
          Balance Sheet
        </Typography>
        <Typography variant="body2" sx={{ color: '#64748b', mb: 2.5 }}>
          Enter password to access
        </Typography>
        <TextField
              fullWidth
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter your password"
              error={!!error}
              helperText={error}
              sx={{
                mb: 3,
                '& .MuiOutlinedInput-root': {
                  borderRadius: 2,
                  '& fieldset': {
                    borderColor: '#e2e8f0',
                  },
                  '&:hover fieldset': {
                    borderColor: appColors.leaf,
                  },
                  '&.Mui-focused fieldset': {
                    borderColor: appColors.leaf,
                    borderWidth: 2,
                  },
                },
              }}
            />
        <Box sx={{ display: 'flex', gap: 2, mt: 1 }}>
          <Button
            variant="outlined"
            onClick={handlePasswordCancel}
            startIcon={<CancelIcon />}
            fullWidth
            sx={{
              borderColor: '#94a3b8',
              color: '#475569',
              textTransform: 'none',
              fontWeight: 600,
              py: 1.5,
              borderRadius: 2,
              boxShadow: 'none',
              '&:hover': {
                borderColor: '#64748b',
                bgcolor: 'rgba(100, 116, 139, 0.08)',
                boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
              },
            }}
          >
            Cancel
          </Button>
          <Button
            fullWidth
            variant="contained"
            onClick={handlePasswordSubmit}
            disabled={verifying}
            sx={{
              bgcolor: appColors.leaf,
              py: 1.5,
              borderRadius: 2,
              textTransform: 'none',
              fontWeight: 600,
              boxShadow: '0 4px 14px rgba(31, 122, 84, 0.35)',
              '&:hover': {
                bgcolor: appColors.pine,
                boxShadow: '0 6px 20px rgba(31, 122, 84, 0.4)',
                transform: 'translateY(-1px)',
              },
              transition: 'all 0.2s ease',
            }}
          >
            {verifying ? 'Verifying...' : 'Submit'}
          </Button>
        </Box>
        </Box>
        </Modal>
      </Box>
    </Box>
  );
}

export default BalanceSheet;